import { Component, OnInit, Inject,ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";


@Component({
  selector: 'app-show-calender-events-dialog',
  templateUrl: './show-calender-events-dialog.component.html',
  styleUrls: ['./show-calender-events-dialog.component.scss']
})
export class ShowCalenderEventsDialogComponent implements OnInit {
  appointmentType:String;
  dateTime : Date;
  location:String;
  contactFirstName:String;
  contactLastName:String;
  projectName:String;
  eventList:any[] = [];
  constructor(
    public dialogRef: MatDialogRef<ShowCalenderEventsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  ngOnInit() {
    
    this.eventList = this.data;
  }

  hideEditProjectDialog() {
    this.dialogRef.close();
  }

 

}
